
import { useState } from 'react';
import { toast } from 'sonner';
import { performBitcoinVerification } from './card-verification/bitcoinVerification';

export const useBitcoinVerification = () => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [verificationScore, setVerificationScore] = useState<number | null>(null);
  const [riskLevel, setRiskLevel] = useState<'low' | 'medium' | 'high' | null>(null);
  const [verificationError, setVerificationError] = useState<string | undefined>();
  const [bitcoinAddress, setBitcoinAddress] = useState<string>('');

  const resetVerification = () => {
    setIsVerifying(false);
    setIsVerified(false);
    setVerificationScore(null);
    setRiskLevel(null);
    setVerificationError(undefined);
  };

  const verifyBitcoin = async (address: string, amount: number) => {
    if (isVerifying) {
      return {
        success: false,
        message: 'Verification already in progress',
        score: 0,
        riskLevel: 'high',
        stripeReady: false,
      };
    }

    try {
      setIsVerifying(true);
      setVerificationError(undefined);
      setBitcoinAddress(address);
      
      console.log(`Verifying Bitcoin address: ${address}`);

      const result = await performBitcoinVerification(address, amount);
      
      setIsVerifying(false);
      setIsVerified(result.success);
      setVerificationScore(result.score);
      setRiskLevel(result.riskLevel);
      
      if (!result.success) {
        setVerificationError(result.message);
        toast.error(result.message || 'Bitcoin verification failed');
      }
      
      return result;
    } catch (error: any) {
      console.error('Bitcoin verification error:', error);
      
      setIsVerifying(false);
      setIsVerified(false);
      setVerificationError(error.message);
      
      toast.error(error.message || 'Bitcoin verification failed');
      
      return {
        success: false,
        message: error.message,
        score: 0,
        riskLevel: 'high',
        stripeReady: false,
      };
    }
  };

  const onVerificationComplete = (success: boolean) => {
    if (!success) {
      resetVerification();
    }
  };

  return {
    isVerifying,
    isVerified,
    verificationScore,
    riskLevel,
    verificationError,
    bitcoinAddress,
    verifyBitcoin,
    resetVerification,
    onVerificationComplete
  };
};
